/* SilentTrax — theme JS */
(function () {
  'use strict';

  // ---------- GTM-ready dataLayer ----------
  window.dataLayer = window.dataLayer || [];
  function dl(event, data) {
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }
  window.silentTraxDL = dl;
  dl('st.page_view', { page_type: document.body.className });

  // ---------- Service worker register (assets cache only) ----------
  if ('serviceWorker' in navigator && location.protocol === 'https:') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('{{ "sw.js" | asset_url }}'.replace(/\?.*$/, '')).catch(() => {});
    });
  }

  // ---------- A11y: high-contrast + font size persistence ----------
  try {
    const a11y = JSON.parse(localStorage.getItem('st_a11y') || '{}');
    if (a11y.contrast) document.documentElement.classList.add('a11y-contrast');
    if (a11y.fontSize) document.documentElement.style.setProperty('--a11y-font-scale', a11y.fontSize);
  } catch (e) {}
  window.silentTraxA11y = {
    toggleContrast() {
      document.documentElement.classList.toggle('a11y-contrast');
      const s = JSON.parse(localStorage.getItem('st_a11y') || '{}');
      s.contrast = document.documentElement.classList.contains('a11y-contrast');
      localStorage.setItem('st_a11y', JSON.stringify(s));
    },
    setFontSize(scale) {
      document.documentElement.style.setProperty('--a11y-font-scale', scale);
      const s = JSON.parse(localStorage.getItem('st_a11y') || '{}');
      s.fontSize = scale;
      localStorage.setItem('st_a11y', JSON.stringify(s));
    }
  };

  // ---------- Web Vitals → dataLayer (CLS, LCP, INP, FCP, TTFB) ----------
  if (document.documentElement.dataset.trackVitals !== 'false') {
    import('https://unpkg.com/web-vitals@4?module').then(({onCLS, onLCP, onINP, onFCP, onTTFB}) => {
      const send = (m) => dl('st.web_vital', { metric: m.name, value: Math.round(m.value), rating: m.rating });
      onCLS(send); onLCP(send); onINP(send); onFCP(send); onTTFB(send);
    }).catch(() => {});
  }

  // ---------- Native Web Share (когато налично) ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-native-share]');
    if (!btn) return;
    if (!navigator.share) return;
    e.preventDefault();
    try {
      await navigator.share({
        title: document.title,
        url: btn.dataset.shareUrl || window.location.href
      });
      dl('st.native_share');
    } catch (err) {}
  });

  // ---------- Confetti на order success page ----------
  if (window.location.pathname.includes('/thank-you') || document.body.classList.contains('template-checkout-thank-you')) {
    setTimeout(() => {
      const c = document.createElement('canvas');
      c.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999';
      document.body.appendChild(c);
      c.width = window.innerWidth; c.height = window.innerHeight;
      const ctx = c.getContext('2d');
      const colors = ['#CFFF04', '#A8D203', '#C8A04D', '#F5F2EC'];
      const particles = Array.from({ length: 140 }, () => ({
        x: Math.random() * c.width, y: -20 - Math.random() * 100,
        vx: (Math.random() - 0.5) * 4, vy: 2 + Math.random() * 3,
        r: 4 + Math.random() * 6, color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.2
      }));
      let frames = 0;
      function tick() {
        ctx.clearRect(0, 0, c.width, c.height);
        particles.forEach(p => {
          p.x += p.vx; p.y += p.vy; p.vy += 0.05; p.rot += p.vr;
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.fillStyle = p.color; ctx.fillRect(-p.r/2, -p.r/3, p.r, p.r*0.6);
          ctx.restore();
        });
        if (++frames < 360) requestAnimationFrame(tick);
        else c.remove();
      }
      tick();
    }, 200);
  }

  // ---------- Product image fade-in on load ----------
  document.querySelectorAll('.product-card__img--primary').forEach((img) => {
    if (img.complete) img.classList.add('loaded');
    else img.addEventListener('load', () => img.classList.add('loaded'));
  });

  // ---------- Sticky header shadow on scroll + has-scrolled body class ----------
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (header) header.classList.toggle('scrolled', window.scrollY > 8);
    document.body.classList.toggle('has-scrolled', window.scrollY > 80);
  };
  onScroll();
  document.addEventListener('scroll', onScroll, { passive: true });

  // ---------- Cmd/Ctrl+K opens search drawer ----------
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      const sd = document.querySelector('[data-search-drawer]');
      if (sd) {
        e.preventDefault();
        sd.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-search-open');
        const input = sd.querySelector('[data-search-input]');
        setTimeout(() => input?.focus(), 60);
      }
    }
  });

  // ---------- Scroll reveal (.reveal, .reveal-up, .reveal-fade) ----------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal, .reveal-up, .reveal-fade').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal, .reveal-up, .reveal-fade').forEach((el) => el.classList.add('is-visible'));
  }

  // ---------- Swipe to close drawers (mobile) ----------
  function attachDrawerSwipe(drawerEl, closeFn, direction) {
    const panel = drawerEl?.querySelector('.cart-drawer__panel, .mobile-drawer__panel, .search-drawer__panel');
    if (!panel) return;
    addSwipe(panel,
      direction === 'right' ? closeFn : null,
      direction === 'left' ? closeFn : null,
      direction === 'down' ? closeFn : null
    );
  }

  // ---------- Mobile nav drawer ----------
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  if (mobileDrawer) {
    function setMobileOpen(open) {
      mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('is-mobile-open', open);
      if (open) {
        const closeBtn = mobileDrawer.querySelector('[data-mobile-close]:not(.mobile-drawer__overlay)');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }
    }
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-mobile-toggle]');
      if (toggle) { e.preventDefault(); setMobileOpen(true); return; }
      const close = e.target.closest('[data-mobile-close]');
      if (close && mobileDrawer.contains(close)) { setMobileOpen(false); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileDrawer.getAttribute('aria-hidden') === 'false') setMobileOpen(false);
    });
  }

  // ---------- Toast ----------
  const toast = document.querySelector('[data-toast]');
  let toastTimer = null;
  function showToast(message, opts) {
    if (!toast) return;
    opts = opts || {};
    toast.textContent = '';
    if (opts.icon) {
      const i = document.createElement('span');
      i.className = 'toast__icon';
      i.textContent = opts.icon;
      toast.appendChild(i);
    }
    const t = document.createElement('span');
    t.className = 'toast__text';
    t.textContent = message;
    toast.appendChild(t);
    if (opts.action && opts.actionUrl) {
      const a = document.createElement('a');
      a.className = 'toast__action';
      a.href = opts.actionUrl;
      a.textContent = opts.action + ' →';
      toast.appendChild(a);
    }
    toast.classList.add('is-visible');
    toast.dataset.kind = opts.kind || 'info';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), opts.duration || 2600);
  }
  window.silentTraxToast = showToast;

  // ---------- Product sticky mobile add-to-cart ----------
  const stickybar = document.querySelector('[data-product-stickybar]');
  const productForm = document.getElementById('product-form');
  if (stickybar && productForm) {
    document.body.classList.add('has-stickybar');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const visible = !e.isIntersecting;
        stickybar.classList.toggle('is-visible', visible);
        stickybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        // On mobile, hide bottom nav when sticky ATC is shown to avoid overlap
        document.body.classList.toggle('stickybar-visible', visible);
      });
    }, { rootMargin: '0px 0px -100px 0px' });
    io.observe(productForm);

    const stickyBtn = stickybar.querySelector('[data-product-stickybar-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const submit = productForm.querySelector('button[type=submit].product__submit') || productForm.querySelector('button[type=submit]');
        if (submit) submit.click();
      });
    }
  }

  // ---------- Cookie consent ----------
  const COOKIE_KEY = 'st_cookie_consent';
  const consent = document.querySelector('[data-cookie-consent]');
  if (consent) {
    const stored = localStorage.getItem(COOKIE_KEY);
    if (!stored) {
      setTimeout(() => { consent.hidden = false; consent.classList.add('is-visible'); }, 1200);
    }
    consent.addEventListener('click', (e) => {
      const accept = e.target.closest('[data-cookie-accept]');
      const decline = e.target.closest('[data-cookie-decline]');
      if (accept || decline) {
        localStorage.setItem(COOKIE_KEY, accept ? 'accepted' : 'declined');
        consent.classList.remove('is-visible');
        setTimeout(() => { consent.hidden = true; }, 320);
      }
    });
  }

  // ---------- Floating contact ----------
  const floating = document.querySelector('[data-floating-contact]');
  if (floating) {
    const trigger = floating.querySelector('[data-floating-toggle]');
    trigger?.addEventListener('click', () => {
      const open = floating.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!floating.contains(e.target) && floating.classList.contains('is-open')) {
        floating.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ---------- Swipe gesture helpers ----------
  function addSwipe(el, onLeft, onRight, onDown) {
    if (!el) return;
    let sx = 0, sy = 0, dx = 0, dy = 0, touching = false;
    el.addEventListener('touchstart', (e) => {
      const t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; dy = 0; touching = true;
    }, { passive: true });
    el.addEventListener('touchmove', (e) => {
      if (!touching) return; const t = e.touches[0]; dx = t.clientX - sx; dy = t.clientY - sy;
    }, { passive: true });
    el.addEventListener('touchend', () => {
      if (!touching) return; touching = false;
      const abx = Math.abs(dx), aby = Math.abs(dy);
      if (abx > 40 && abx > aby) { if (dx < 0) onLeft?.(); else onRight?.(); }
      else if (dy > 60 && aby > abx) { onDown?.(); }
    });
  }

  // ---------- Product image lightbox ----------
  const galleryImgs = document.querySelectorAll('.product__media-item img');
  if (galleryImgs.length > 0) {
    const all = Array.from(galleryImgs);
    let lightboxEl = null;
    let currentIdx = 0;

    function buildLightbox() {
      const lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-hidden', 'true');
      lb.innerHTML = `
        <div class="lightbox__overlay" data-lightbox-close></div>
        <button type="button" class="lightbox__close" data-lightbox-close aria-label="Close">
          <svg width="22" height="22" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg>
        </button>
        <button type="button" class="lightbox__nav lightbox__nav--prev" data-lightbox-prev aria-label="Previous">
          <svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="m12 4-6 6 6 6"/></svg>
        </button>
        <img class="lightbox__img" alt="">
        <button type="button" class="lightbox__nav lightbox__nav--next" data-lightbox-next aria-label="Next">
          <svg width="26" height="26" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="m8 4 6 6-6 6"/></svg>
        </button>
        <div class="lightbox__counter mono"></div>
      `;
      document.body.appendChild(lb);
      return lb;
    }

    function show(idx) {
      if (!lightboxEl) lightboxEl = buildLightbox();
      currentIdx = (idx + all.length) % all.length;
      const src = all[currentIdx].dataset.full || all[currentIdx].currentSrc || all[currentIdx].src;
      const fullSrc = src.replace(/(\?|&)width=\d+/, '$1width=1800');
      lightboxEl.querySelector('.lightbox__img').src = fullSrc;
      lightboxEl.querySelector('.lightbox__img').alt = all[currentIdx].alt || '';
      lightboxEl.querySelector('.lightbox__counter').textContent = `${currentIdx + 1} / ${all.length}`;
      lightboxEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-lightbox-open');
    }
    function close() {
      if (!lightboxEl) return;
      lightboxEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-lightbox-open');
    }

    all.forEach((img, i) => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => show(i));
    });
    document.addEventListener('click', (e) => {
      if (!lightboxEl || lightboxEl.getAttribute('aria-hidden') === 'true') return;
      if (e.target.closest('[data-lightbox-close]')) close();
      else if (e.target.closest('[data-lightbox-prev]')) show(currentIdx - 1);
      else if (e.target.closest('[data-lightbox-next]')) show(currentIdx + 1);
    });
    document.addEventListener('keydown', (e) => {
      if (!lightboxEl || lightboxEl.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(currentIdx - 1);
      else if (e.key === 'ArrowRight') show(currentIdx + 1);
    });
    // Swipe in lightbox
    setTimeout(() => {
      if (lightboxEl) {
        addSwipe(lightboxEl, () => show(currentIdx + 1), () => show(currentIdx - 1), () => close());
      }
    }, 1000);
  }

  // ---------- Recently viewed (localStorage) ----------
  const RV_KEY = 'st_recently_viewed';
  const productHandle = document.body.dataset.productHandle;
  if (productHandle) {
    try {
      let list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      list = [productHandle, ...list.filter(h => h !== productHandle)].slice(0, 12);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // ---------- Wishlist (localStorage) ----------
  const WISH_KEY = 'st_wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeWishlist(list) { localStorage.setItem(WISH_KEY, JSON.stringify(list)); updateWishCount(); refreshWishMarks(); }
  function toggleWish(handle) {
    const list = readWishlist();
    const idx = list.indexOf(handle);
    if (idx >= 0) list.splice(idx, 1); else list.unshift(handle);
    writeWishlist(list);
    return idx < 0;
  }
  function updateWishCount() {
    const list = readWishlist();
    document.querySelectorAll('[data-wish-count]').forEach((el) => {
      el.textContent = list.length;
      el.dataset.count = list.length;
    });
  }
  function refreshWishMarks() {
    const list = readWishlist();
    document.querySelectorAll('[data-wish-toggle]').forEach((btn) => {
      btn.classList.toggle('is-active', list.includes(btn.dataset.wishToggle));
    });
  }
  updateWishCount();
  refreshWishMarks();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const added = toggleWish(btn.dataset.wishToggle);
    btn.classList.toggle('is-active', added);
    const lang = document.documentElement.lang || '';
    const isEn = lang.startsWith('en');
    const msg = added
      ? (isEn ? 'Added to wishlist' : 'Добавено в любими')
      : (isEn ? 'Removed from wishlist' : 'Премахнато от любими');
    if (window.silentTraxToast) window.silentTraxToast(msg, { icon: added ? '♥' : '♡', kind: 'success' });
    dl('st.wish_toggle', { handle: btn.dataset.wishToggle, added });
  });

  // Render wishlist page if present
  const wishGrid = document.querySelector('[data-wishlist-grid]');
  if (wishGrid) {
    (async () => {
      const list = readWishlist();
      const empty = document.querySelector('[data-wishlist-empty]');
      const actions = document.querySelector('[data-wishlist-actions]');
      if (list.length === 0) return;
      empty.hidden = true;
      wishGrid.hidden = false;
      actions.hidden = false;
      for (const handle of list) {
        try {
          const res = await fetch(`/products/${handle}?view=card-only`, { headers: { Accept: 'text/html' } });
          if (!res.ok) continue;
          const html = await res.text();
          // Extract product data from product.js endpoint instead
          const pRes = await fetch(`/products/${handle}.js`);
          if (!pRes.ok) continue;
          const p = await pRes.json();
          const card = document.createElement('div');
          card.className = 'product-card-wrap';
          const img = (p.featured_image || (p.images && p.images[0]) || '');
          const onSale = p.compare_at_price && p.compare_at_price > p.price;
          card.innerHTML = `
            <button type="button" class="product-card__wish is-active" data-wish-toggle="${p.handle}" aria-label="Remove from wishlist">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            </button>
            <a href="${p.url}" class="product-card" aria-label="${escapeHtmlGlobal(p.title)}">
              <div class="product-card__media">
                ${img ? `<img class="product-card__img product-card__img--primary" src="${img}&width=600" alt="${escapeHtmlGlobal(p.title)}" loading="lazy">` : ''}
              </div>
              <div class="product-card__body">
                <h3 class="product-card__title">${escapeHtmlGlobal(p.title)}</h3>
                <div class="product-card__price">
                  ${onSale ? `<span class="compare">${fmtMoneyGlobal(p.compare_at_price)}</span><span class="sale">${fmtMoneyGlobal(p.price)}</span>` : fmtMoneyGlobal(p.price)}
                </div>
              </div>
            </a>`;
          wishGrid.appendChild(card);
        } catch (e) { /* skip */ }
      }
    })();

    document.querySelector('[data-wishlist-clear]')?.addEventListener('click', () => {
      writeWishlist([]);
      location.reload();
    });

    document.querySelector('[data-wishlist-share]')?.addEventListener('click', async () => {
      const list = readWishlist();
      if (list.length === 0) return;
      const lang = document.documentElement.lang || '';
      const isEn = lang.startsWith('en');
      const url = `${location.origin}/pages/wishlist?w=${encodeURIComponent(list.join(','))}`;
      const title = isEn ? 'My SilentTrax wishlist' : 'Моите любими от SilentTrax';
      if (navigator.share) {
        try { await navigator.share({ title, url }); } catch (e) {}
      } else {
        try {
          await navigator.clipboard.writeText(url);
          if (window.silentTraxToast) window.silentTraxToast(isEn ? 'Link copied' : 'Линкът е копиран', { icon: '✓', kind: 'success' });
        } catch (e) {}
      }
    });

    const urlParams = new URLSearchParams(location.search);
    const shared = urlParams.get('w');
    if (shared) {
      const incoming = shared.split(',').filter(Boolean);
      const merged = [...new Set([...incoming, ...readWishlist()])].slice(0, 24);
      writeWishlist(merged);
    }
  }

  function escapeHtmlGlobal(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
  function fmtMoneyGlobal(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ---------- Quick view modal ----------
  const qvModal = document.querySelector('[data-quickview-modal]');
  if (qvModal) {
    const qvBody = qvModal.querySelector('[data-quickview-body]');
    async function openQuickview(handle) {
      dl('st.quickview_open', { handle });
      qvModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-quickview-open');
      qvBody.innerHTML = '<div class="quickview__loading">…</div>';
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error('failed');
        const p = await res.json();
        const lang = document.documentElement.lang || '';
        const isEn = lang.startsWith('en');
        const addLabel = isEn ? 'Add to cart' : 'Добави в количката';
        const fullLabel = isEn ? 'View full details' : 'Виж пълни детайли';
        const img = p.featured_image || (p.images && p.images[0]) || '';
        const description = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 220);
        qvBody.innerHTML = `
          <div class="quickview__grid">
            <div class="quickview__media">
              ${img ? `<img src="${img}&width=900" alt="${escapeHtmlGlobal(p.title)}">` : ''}
            </div>
            <div class="quickview__info">
              ${p.vendor ? `<div class="eyebrow">${escapeHtmlGlobal(p.vendor)}</div>` : ''}
              <h2 class="quickview__title">${escapeHtmlGlobal(p.title)}</h2>
              <div class="quickview__price mono">${fmtMoneyGlobal(p.price)}</div>
              ${description ? `<p class="quickview__desc">${escapeHtmlGlobal(description)}…</p>` : ''}
              <form action="/cart/add" method="post" class="quickview__form">
                <input type="hidden" name="id" value="${p.variants[0].id}">
                <input type="hidden" name="quantity" value="1">
                <button type="submit" class="btn btn-primary btn-lg">${escapeHtmlGlobal(addLabel)} <span class="arrow">→</span></button>
                <a href="${p.url}" class="btn-text">${escapeHtmlGlobal(fullLabel)} →</a>
              </form>
            </div>
          </div>`;
      } catch (e) {
        qvBody.innerHTML = '<div class="quickview__loading">Error</div>';
      }
    }
    function closeQuickview() {
      qvModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-quickview-open');
    }
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-quickview]');
      if (open) { e.preventDefault(); e.stopPropagation(); openQuickview(open.dataset.quickview); return; }
      if (e.target.closest('[data-quickview-close]')) closeQuickview();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && qvModal.getAttribute('aria-hidden') === 'false') closeQuickview();
    });
  }

  // ---------- Compare products (localStorage) ----------
  const CMP_KEY = 'st_compare';
  const cmpBar = document.querySelector('[data-compare-bar]');
  function readCmp() { try { return JSON.parse(localStorage.getItem(CMP_KEY) || '[]'); } catch (e) { return []; } }
  function writeCmp(list) { localStorage.setItem(CMP_KEY, JSON.stringify(list)); renderCmpBar(); refreshCmpMarks(); }
  function refreshCmpMarks() {
    const list = readCmp();
    document.querySelectorAll('[data-compare-toggle]').forEach((b) => {
      b.classList.toggle('is-active', list.includes(b.dataset.compareToggle));
    });
  }
  function renderCmpBar() {
    if (!cmpBar) return;
    const list = readCmp();
    if (list.length === 0) { cmpBar.hidden = true; return; }
    cmpBar.hidden = false;
    const lang = document.documentElement.lang || '';
    const isEn = lang.startsWith('en');
    cmpBar.querySelector('[data-compare-label]').textContent = isEn ? `Compare (${list.length}/3)` : `Сравни (${list.length}/3)`;
    cmpBar.querySelector('[data-compare-items]').innerHTML = list.map((h) => `<span class="compare-bar__item mono">${h.slice(0, 20)}<button type="button" data-compare-remove="${h}" aria-label="Remove">×</button></span>`).join('');
  }
  function toggleCmp(handle) {
    const list = readCmp();
    const i = list.indexOf(handle);
    if (i >= 0) { list.splice(i, 1); }
    else if (list.length < 3) { list.push(handle); }
    else {
      const lang = document.documentElement.lang || '';
      const isEn = lang.startsWith('en');
      if (window.silentTraxToast) window.silentTraxToast(isEn ? 'Compare max 3 products' : 'Максимум 3 продукта', { kind: 'info' });
      return false;
    }
    writeCmp(list);
    return true;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-compare-toggle]');
    if (btn) { e.preventDefault(); e.stopPropagation(); toggleCmp(btn.dataset.compareToggle); return; }
    const rm = e.target.closest('[data-compare-remove]');
    if (rm) { e.preventDefault(); toggleCmp(rm.dataset.compareRemove); return; }
    const clear = e.target.closest('[data-compare-clear]');
    if (clear) { writeCmp([]); return; }
    const open = e.target.closest('[data-compare-open]');
    if (open) { e.preventDefault(); openCompare(); return; }
    const cclose = e.target.closest('[data-compare-close]');
    if (cclose) { closeCompare(); return; }
  });

  const cmpModal = document.querySelector('[data-compare-modal]');
  async function openCompare() {
    if (!cmpModal) return;
    const list = readCmp();
    if (list.length === 0) return;
    const body = cmpModal.querySelector('[data-compare-body]');
    body.innerHTML = '<div class="compare-modal__loading">…</div>';
    cmpModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-compare-open');
    const lang = document.documentElement.lang || '';
    const isEn = lang.startsWith('en');
    const rows = [
      { key: 'image', label: '' },
      { key: 'title', label: isEn ? 'Product' : 'Продукт' },
      { key: 'vendor', label: isEn ? 'Brand' : 'Марка' },
      { key: 'price', label: isEn ? 'Price' : 'Цена' },
      { key: 'variants', label: isEn ? 'Options' : 'Опции' },
      { key: 'cta', label: '' }
    ];
    try {
      const products = await Promise.all(list.map((h) => fetch(`/products/${h}.js`).then((r) => r.ok ? r.json() : null)));
      const valid = products.filter(Boolean);
      const cells = (key, p) => {
        if (key === 'image') return p.featured_image ? `<img src="${p.featured_image}&width=400" alt="" loading="lazy">` : '';
        if (key === 'title') return `<a href="${p.url}">${escapeHtmlGlobal(p.title)}</a>`;
        if (key === 'vendor') return escapeHtmlGlobal(p.vendor || '—');
        if (key === 'price') return `<span class="accent">${fmtMoneyGlobal(p.price)}</span>`;
        if (key === 'variants') return (p.variants || []).length;
        if (key === 'cta') return `<a href="${p.url}" class="btn btn-primary btn-sm">${isEn ? 'View' : 'Виж'} →</a>`;
        return '';
      };
      body.innerHTML = `
        <table class="compare-table">
          ${rows.map((r) => `
            <tr>
              <th>${r.label}</th>
              ${valid.map((p) => `<td data-key="${r.key}">${cells(r.key, p)}</td>`).join('')}
            </tr>
          `).join('')}
        </table>`;
    } catch (e) {
      body.innerHTML = `<div class="compare-modal__loading">Error</div>`;
    }
  }
  function closeCompare() {
    cmpModal?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-compare-open');
  }
  renderCmpBar();
  refreshCmpMarks();

  // ---------- PDP thumbnail strip ----------
  const galleryEl = document.querySelector('[data-product-gallery]');
  if (galleryEl) {
    const thumbs = galleryEl.querySelectorAll('[data-thumb-index]');
    const slides = galleryEl.querySelectorAll('.product__media-item');
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const i = parseInt(t.dataset.thumbIndex, 10);
        thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
        slides.forEach((s) => s.classList.toggle('is-active', parseInt(s.dataset.mediaIndex, 10) === i));
      });
    });
  }

  // ---------- Hero parallax + scroll progress bar ----------
  const heroBg = document.querySelector('.hero__bg img');
  const progressEl = document.createElement('div');
  progressEl.className = 'scroll-progress';
  progressEl.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progressEl);
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let scrollRaf = null;
  function onScrollPolish() {
    const y = window.scrollY;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const pct = max > 0 ? (y / max) : 0;
    progressEl.style.transform = `scaleX(${pct})`;
    if (heroBg && !prefersReduced && y < 800) {
      heroBg.style.transform = `translate3d(0, ${y * 0.15}px, 0) scale(${1 + y * 0.00015})`;
    }
  }
  document.addEventListener('scroll', () => {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(() => { onScrollPolish(); scrollRaf = null; });
  }, { passive: true });
  onScrollPolish();

  // ---------- Animated stat counters ----------
  const stats = document.querySelectorAll('.stat__number');
  if (stats.length > 0 && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const counter = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const raw = el.textContent.trim();
        const numMatch = raw.match(/[\d.,]+/);
        if (!numMatch) { counter.unobserve(el); return; }
        const numStr = numMatch[0].replace(',', '.');
        const target = parseFloat(numStr);
        const decimals = (numStr.split('.')[1] || '').length;
        const prefix = raw.slice(0, numMatch.index);
        const suffix = raw.slice(numMatch.index + numMatch[0].length);
        const duration = 1600;
        const start = performance.now();
        function step(t) {
          const p = Math.min(1, (t - start) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          const current = target * eased;
          el.textContent = prefix + current.toFixed(decimals).replace('.', decimals > 0 ? ',' : '') + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counter.unobserve(el);
      });
    }, { threshold: 0.4 });
    stats.forEach((s) => counter.observe(s));
  }

  // ---------- Cart drawer ----------
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    const panel = drawer.querySelector('.cart-drawer__panel');

    function setOpen(open) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('is-cart-open', open);
      if (open) {
        const closeBtn = drawer.querySelector('[data-cart-close]:not(.cart-drawer__overlay)');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      }
    }

    async function refreshDrawer() {
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`, {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('section fetch failed');
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newInner = tmp.querySelector('[data-cart-drawer-inner]');
        const oldInner = panel.querySelector('[data-cart-drawer-inner]');
        if (newInner && oldInner) oldInner.replaceWith(newInner);
        updateCartCount();
      } catch (err) {
        console.warn('[cart] refresh failed', err);
      }
    }

    async function updateCartCount() {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      } catch (e) { /* noop */ }
    }

    async function openCart() {
      setOpen(true);
      await refreshDrawer();
    }
    function closeCart() { setOpen(false); }

    // Click handlers (delegated)
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); openCart(); return; }
      const close = e.target.closest('[data-cart-close]');
      if (close && drawer.contains(close)) { e.preventDefault(); closeCart(); return; }
    });

    // Esc to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeCart();
    });

    // Qty + remove (delegated, inside drawer)
    let qtyTimer = null;
    drawer.addEventListener('click', async (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (step) {
        const wrap = step.closest('[data-qty-control]');
        const input = wrap.querySelector('[data-qty-input]');
        const delta = parseInt(step.dataset.qtyStep, 10);
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        const line = step.closest('[data-line-key]');
        await changeLine(line.dataset.lineKey, next);
        return;
      }
      const rm = e.target.closest('[data-line-remove]');
      if (rm) {
        const line = rm.closest('[data-line-key]');
        await changeLine(line.dataset.lineKey, 0);
        return;
      }
      const save = e.target.closest('[data-line-save]');
      if (save) {
        const handle = save.dataset.lineHandle;
        const line = save.closest('[data-line-key]');
        try {
          const list = JSON.parse(localStorage.getItem('st_wishlist') || '[]');
          if (!list.includes(handle)) list.unshift(handle);
          localStorage.setItem('st_wishlist', JSON.stringify(list));
          document.querySelectorAll('[data-wish-count]').forEach((el) => { el.textContent = list.length; el.dataset.count = list.length; });
        } catch (err) {}
        await changeLine(line.dataset.lineKey, 0);
        const lang = document.documentElement.lang || '';
        const isEn = lang.startsWith('en');
        if (window.silentTraxToast) window.silentTraxToast(isEn ? 'Saved for later' : 'Запазено за по-късно', { icon: '♥', kind: 'success' });
        return;
      }
    });
    drawer.addEventListener('change', async (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const line = input.closest('[data-line-key]');
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = qty;
      await changeLine(line.dataset.lineKey, qty);
    });

    // Cart note save (debounced)
    let noteTimer = null;
    drawer.addEventListener('input', (e) => {
      const note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(async () => {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        } catch (e) {}
      }, 500);
    });

    async function changeLine(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!res.ok) throw new Error('change failed');
        await refreshDrawer();
      } catch (err) {
        console.warn('[cart] change failed', err);
      }
    }

    // Intercept add-to-cart forms
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const submitBtn = form.querySelector('[type=submit]');
      const originalLabel = submitBtn?.textContent;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Добавяне…'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'add failed');
        }
        const lang = document.documentElement.lang || '';
        const isEn = lang.startsWith('en');
        const addedMsg = isEn ? 'Added to cart' : 'Добавено в количката';
        showToast(addedMsg, { icon: '✓', kind: 'success', action: isEn ? 'View cart' : 'Виж количка', actionUrl: '/cart' });
        document.querySelectorAll('.cart-count').forEach((c) => {
          c.classList.remove('pulse');
          void c.offsetWidth;
          c.classList.add('pulse');
        });
        dl('st.add_to_cart', { form_id: form.id || null });
        await openCart();
      } catch (err) {
        console.warn('[cart] add failed', err);
        const inner = drawer.querySelector('[data-cart-drawer-inner]');
        const fallback = inner?.dataset.i18nAdderror || 'Error adding to cart.';
        alert(err.message || fallback);
      } finally {
        if (submitBtn) { submitBtn.disabled = false; if (originalLabel) submitBtn.textContent = originalLabel; }
      }
    });

    // Make header cart icon open the drawer
    document.querySelectorAll('a.cart-bubble, a[href$="/cart"]').forEach((a) => {
      a.setAttribute('data-cart-toggle', '');
    });

    // Initial count sync (in case server-rendered count is stale after navigation)
    updateCartCount();
  }

  // ---------- Search drawer ----------
  const searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchDrawer) {
    const input = searchDrawer.querySelector('[data-search-input]');
    const results = searchDrawer.querySelector('[data-search-results]');
    let debounceId = null;
    let currentReq = null;

    function setSearchOpen(open) {
      searchDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('is-search-open', open);
      if (open) setTimeout(() => input?.focus(), 60);
    }

    function fmtMoney(cents) {
      const v = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + v;
    }

    function getI18n() {
      const inner = searchDrawer.querySelector('.search-drawer__inner');
      return {
        loading: inner?.dataset.i18nLoading || 'Searching…',
        noresults: inner?.dataset.i18nNoresults || 'No results for',
        error: inner?.dataset.i18nError || 'Search failed. Try again.',
        viewall: inner?.dataset.i18nViewall || 'View all results →',
        hint: inner?.dataset.i18nHint || 'Start typing — results appear in real time.'
      };
    }

    const HISTORY_KEY = 'st_search_history';
    function readHistory() { try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch (e) { return []; } }
    function pushHistory(q) {
      const list = readHistory();
      const next = [q, ...list.filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, 6);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
    }

    function renderEmptyState() {
      const i = getI18n();
      const lang = document.documentElement.lang || '';
      const isEn = lang.startsWith('en');
      const history = readHistory();
      const popular = isEn
        ? ['Sur-Ron', 'Ultra Bee', 'Talaria', 'conversion kit', '72V battery']
        : ['Sur-Ron', 'Ultra Bee', 'Talaria', 'конверсия комплект', 'батерия 72V'];
      const cats = isEn
        ? [['Motorcycles', '/collections/e-bikes'], ['Kits', '/collections/conversion-kits'], ['Batteries', '/collections/batteries'], ['Bundles', '/collections/bundles']]
        : [['Мотори', '/collections/e-bikes'], ['Комплекти', '/collections/conversion-kits'], ['Батерии', '/collections/batteries'], ['Пакети', '/collections/bundles']];
      const historyLabel = isEn ? 'Recent' : 'Скоро';
      const popularLabel = isEn ? 'Popular' : 'Популярно';
      const catLabel = isEn ? 'Browse by category' : 'По категория';
      let html = `<div class="search-drawer__hint dim">${escapeHtml(i.hint)}</div>`;
      html += `<div class="search-drawer__group"><div class="search-drawer__group-label mono">${catLabel}</div><div class="search-drawer__chips">`;
      cats.forEach(([label, url]) => {
        html += `<a href="${url}" class="search-drawer__chip search-drawer__chip--cat">${escapeHtml(label)} →</a>`;
      });
      html += `</div></div>`;
      if (history.length > 0) {
        html += `<div class="search-drawer__group"><div class="search-drawer__group-label mono">${historyLabel}</div><div class="search-drawer__chips">`;
        history.forEach((q) => {
          html += `<button type="button" class="search-drawer__chip" data-search-quick="${escapeHtml(q)}">${escapeHtml(q)}</button>`;
        });
        html += `</div></div>`;
      }
      html += `<div class="search-drawer__group"><div class="search-drawer__group-label mono">${popularLabel}</div><div class="search-drawer__chips">`;
      popular.forEach((q) => {
        html += `<button type="button" class="search-drawer__chip" data-search-quick="${escapeHtml(q)}">${escapeHtml(q)}</button>`;
      });
      html += `</div></div>`;
      results.innerHTML = html;
    }

    function render(payload, query) {
      const i = getI18n();
      if (!query) {
        renderEmptyState();
        return;
      }
      const products = payload?.resources?.results?.products || [];
      if (products.length === 0) {
        results.innerHTML = `<div class="search-drawer__empty">${escapeHtml(i.noresults)} &laquo;${escapeHtml(query)}&raquo;.</div>`;
        return;
      }
      const cards = products.map((p) => {
        const img = p.featured_image?.url || p.image || '';
        const price = typeof p.price === 'string' ? p.price : (p.price ? fmtMoney(p.price) : '');
        return `
          <a class="search-result" href="${p.url}">
            <div class="search-result__media">${img ? `<img src="${img}&width=160" alt="" loading="lazy">` : ''}</div>
            <div class="search-result__body">
              <div class="search-result__title">${escapeHtml(p.title)}</div>
              ${price ? `<div class="search-result__price">${price}</div>` : ''}
            </div>
          </a>`;
      }).join('');
      results.innerHTML = `
        <div class="search-results">${cards}</div>
        <div class="search-drawer__view-all">
          <a href="/search?q=${encodeURIComponent(query)}&type=product">${escapeHtml(i.viewall)}</a>
        </div>`;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }

    async function runSearch(q) {
      if (currentReq) currentReq.abort();
      const ctl = new AbortController();
      currentReq = ctl;
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: ctl.signal, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('search failed');
        const data = await res.json();
        render(data, q);
      } catch (err) {
        if (err.name !== 'AbortError') {
          const i = getI18n();
          results.innerHTML = `<div class="search-drawer__empty">${escapeHtml(i.error)}</div>`;
        }
      }
    }

    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-search-toggle]');
      if (toggle) { e.preventDefault(); setSearchOpen(true); return; }
      const close = e.target.closest('[data-search-close]');
      if (close && searchDrawer.contains(close)) { e.preventDefault(); setSearchOpen(false); return; }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchDrawer.getAttribute('aria-hidden') === 'false') setSearchOpen(false);
    });

    if (input) {
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(debounceId);
        if (q.length < 2) { render(null, ''); return; }
        const i = getI18n();
        results.innerHTML = `<div class="search-drawer__loading">${escapeHtml(i.loading)}</div>`;
        debounceId = setTimeout(() => { pushHistory(q); runSearch(q); }, 180);
      });

      // Quick-chip clicks
      searchDrawer.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-search-quick]');
        if (!chip) return;
        e.preventDefault();
        input.value = chip.dataset.searchQuick;
        input.dispatchEvent(new Event('input'));
      });
    }
  }

  // ============================================================
  // PHASE 6 POLISH — page reveal, scroll-direction nav, micro-anims
  // ============================================================

  // ---------- Page reveal (fade body in once everything is parsed) ----------
  (function pageReveal() {
    const reveal = () => requestAnimationFrame(() => document.body.classList.add('page-loaded'));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal, { once: true });
    } else {
      reveal();
    }
    // Safety net — guarantee body becomes visible even if something fails
    setTimeout(() => document.body.classList.add('page-loaded'), 600);
  })();

  // ---------- Scroll-direction state (hide header & bottom nav on scroll down, show on up) ----------
  (function scrollDirection() {
    const header = document.querySelector('.site-header');
    const bottomNav = document.querySelector('[data-bottom-nav]');
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      const delta = y - lastY;
      const goingDown = delta > 4;
      const goingUp = delta < -4;
      // Mark scrolled state once past header
      document.body.classList.toggle('is-scrolled', y > 80);
      if (header) header.classList.toggle('scrolled', y > 40);
      // Only auto-hide after scrolling past a threshold
      if (y > 240) {
        if (goingDown) {
          header && header.classList.add('is-hidden');
          bottomNav && bottomNav.classList.add('is-scrolled-down');
        } else if (goingUp) {
          header && header.classList.remove('is-hidden');
          bottomNav && bottomNav.classList.remove('is-scrolled-down');
        }
      } else {
        header && header.classList.remove('is-hidden');
        bottomNav && bottomNav.classList.remove('is-scrolled-down');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  })();

  // ---------- Wishlist heart-pop on toggle ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle], .product-card__wishlist');
    if (!btn) return;
    btn.classList.remove('just-added');
    void btn.offsetWidth; // force reflow to restart animation
    btn.classList.add('just-added');
    setTimeout(() => btn.classList.remove('just-added'), 520);
  });

  // ---------- Cart drawer line-item removal slide-out anim ----------
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-line-remove]');
    if (!rm) return;
    const line = rm.closest('.cart-drawer__line');
    if (line) {
      line.classList.add('is-removing');
      // The underlying fetch handler still runs; CSS opacity transition gives perceived speed
    }
  });

  // ---------- Bottom nav cart count live updates ----------
  // Listen for cart updates and mirror count into bottom-nav cart icon
  document.addEventListener('st:cart-updated', (e) => {
    const count = (e && e.detail && typeof e.detail.itemCount === 'number') ? e.detail.itemCount : null;
    if (count === null) return;
    document.querySelectorAll('.bottom-nav .bottom-nav__count, .cart-count').forEach(el => {
      if (el.closest('.bottom-nav__item--cart') || el.classList.contains('cart-count') || el.matches('.bottom-nav__item--cart .bottom-nav__count')) {
        el.dataset.count = count;
        el.textContent = count > 0 ? String(count) : '';
      }
    });
  });

  // ---------- Image lazy-loading polish: decoding async on all imgs missing it ----------
  document.querySelectorAll('img:not([decoding])').forEach(img => {
    img.decoding = 'async';
    if (!img.hasAttribute('loading') && !img.closest('.hero, .hero-carousel')) {
      img.loading = 'lazy';
    }
  });

  // ---------- Top loading bar — sleek progress on internal navigation ----------
  (function loadingBar() {
    if (document.querySelector('.st-progress')) return;
    const bar = document.createElement('div');
    bar.className = 'st-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    let timer = null;
    const start = () => {
      bar.style.width = '0';
      bar.classList.add('is-active');
      let pct = 0;
      clearInterval(timer);
      timer = setInterval(() => {
        pct = Math.min(pct + Math.random() * 12, 88);
        bar.style.width = pct + '%';
      }, 220);
    };
    const finish = () => {
      clearInterval(timer);
      bar.style.width = '100%';
      setTimeout(() => bar.classList.remove('is-active'), 240);
      setTimeout(() => { bar.style.width = '0'; }, 520);
    };
    // Intercept internal link clicks
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
      if (a.target === '_blank' || a.hasAttribute('download') || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // Same-origin only
      try {
        const url = new URL(a.href, location.href);
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname && url.search === location.search) return;
      } catch (_) { return; }
      // Skip cart-toggle / drawer-toggle / data-* handlers
      if (a.matches('[data-cart-toggle], [data-search-toggle], [data-mobile-toggle], [data-cart-close], [data-search-close], [data-mobile-close]')) return;
      start();
    });
    // Form submits → also show progress
    document.addEventListener('submit', start);
    // Hide on actual page-show (bfcache restore)
    window.addEventListener('pageshow', finish);
    window.addEventListener('beforeunload', () => { /* page is leaving — let css transition finish naturally */ });
  })();

  // ---------- Live region helper for screen-reader announcements ----------
  (function liveRegion() {
    if (document.getElementById('st-live')) return;
    const lr = document.createElement('div');
    lr.id = 'st-live';
    lr.className = 'live-region';
    lr.setAttribute('aria-live', 'polite');
    lr.setAttribute('aria-atomic', 'true');
    document.body.appendChild(lr);
    window.silentTraxAnnounce = (msg) => {
      lr.textContent = '';
      setTimeout(() => { lr.textContent = msg; }, 50);
    };
    document.addEventListener('st:cart-updated', (e) => {
      const c = e && e.detail && typeof e.detail.itemCount === 'number' ? e.detail.itemCount : null;
      const isEn = (document.documentElement.lang || '').startsWith('en');
      if (c !== null) window.silentTraxAnnounce(isEn ? `Cart updated: ${c} items` : `Количка обновена: ${c} артикула`);
    });
  })();

  // ---------- Magnetic primary CTA (desktop only, subtle attraction) ----------
  (function magneticCTA() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.btn-primary.btn-lg, .btn-primary[data-magnetic]').forEach(btn => {
      btn.dataset.magnetic = '1';
      let raf = null;
      btn.addEventListener('mousemove', (e) => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = btn.getBoundingClientRect();
          const dx = (e.clientX - r.left - r.width / 2) * 0.18;
          const dy = (e.clientY - r.top - r.height / 2) * 0.22;
          btn.style.setProperty('--mag-x', dx + 'px');
          btn.style.setProperty('--mag-y', dy + 'px');
        });
      });
      btn.addEventListener('mouseleave', () => {
        if (raf) cancelAnimationFrame(raf);
        btn.style.setProperty('--mag-x', '0px');
        btn.style.setProperty('--mag-y', '0px');
      });
    });
  })();

  // ---------- Spotlight cursor (tracks mouse on .spotlight-zone) ----------
  (function spotlightCursor() {
    if (window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.spotlight-zone').forEach(zone => {
      zone.addEventListener('mousemove', (e) => {
        const r = zone.getBoundingClientRect();
        zone.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        zone.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  })();

  // ---------- Stagger-grid IO trigger ----------
  (function staggerGrid() {
    const grids = document.querySelectorAll('.stagger-grid');
    if (!grids.length || !('IntersectionObserver' in window)) {
      grids.forEach(g => g.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    grids.forEach(g => io.observe(g));
  })();

  // ---------- Blur-up image onload upgrade ----------
  (function blurUp() {
    document.querySelectorAll('img.blur-up').forEach(img => {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
      }
    });
  })();

  // ---------- Glitch text data-text auto-fill ----------
  (function glitchAutoFill() {
    document.querySelectorAll('.glitch:not([data-text])').forEach(el => {
      el.setAttribute('data-text', (el.textContent || '').trim());
    });
  })();

  // ---------- Reading progress bar (article pages) ----------
  (function readingProgress() {
    const article = document.querySelector('main article, .article__body, .blog-article');
    if (!article) return;
    if (document.querySelector('.reading-progress')) return;
    const bar = document.createElement('div');
    bar.className = 'reading-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    let ticking = false;
    const onScroll = () => {
      const r = article.getBoundingClientRect();
      const total = r.height - window.innerHeight;
      const scrolled = Math.max(0, -r.top);
      const pct = Math.min(100, Math.max(0, (scrolled / total) * 100));
      bar.style.width = pct + '%';
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  })();

  // ---------- Marquee track duplication (for seamless infinite loop) ----------
  (function marqueeDuplicate() {
    document.querySelectorAll('.marquee-text__track').forEach(track => {
      if (track.dataset.duplicated) return;
      track.dataset.duplicated = '1';
      // Clone track contents and append, so the loop ends on identical state
      track.innerHTML += track.innerHTML;
    });
  })();

  // ---------- Generic modal helper ----------
  (function modalHelper() {
    window.silentTraxModal = {
      open(id) {
        const m = typeof id === 'string' ? document.getElementById(id) : id;
        if (!m) return;
        m.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-modal-open');
        // Focus first focusable
        setTimeout(() => {
          const f = m.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          f && f.focus();
        }, 100);
      },
      close(id) {
        const m = typeof id === 'string' ? document.getElementById(id) : id;
        if (!m) return;
        m.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-modal-open');
      }
    };
    document.addEventListener('click', (e) => {
      const openTrg = e.target.closest('[data-modal-open]');
      const closeTrg = e.target.closest('[data-modal-close]');
      if (openTrg) {
        e.preventDefault();
        window.silentTraxModal.open(openTrg.dataset.modalOpen);
      }
      if (closeTrg) {
        const modal = closeTrg.closest('.modal');
        if (modal) window.silentTraxModal.close(modal);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.modal[aria-hidden="false"]');
        if (openModal) window.silentTraxModal.close(openModal);
      }
    });
    // Click outside to close
    document.addEventListener('click', (e) => {
      const overlay = e.target.closest('.modal__overlay');
      if (overlay) window.silentTraxModal.close(overlay.parentElement);
    });
  })();

  // ---------- Sticky promo bar dismiss ----------
  (function stickyPromoDismiss() {
    document.querySelectorAll('.sticky-promo').forEach(promo => {
      const id = promo.dataset.promoId || 'default';
      const key = 'st_sticky_promo_' + id;
      if (localStorage.getItem(key)) { promo.remove(); return; }
      const close = promo.querySelector('.sticky-promo__close');
      if (close) {
        close.addEventListener('click', () => {
          localStorage.setItem(key, String(Date.now()));
          promo.style.transition = 'opacity 240ms, transform 240ms';
          promo.style.opacity = '0';
          promo.style.transform = 'translateY(-100%)';
          setTimeout(() => promo.remove(), 280);
        });
      }
    });
  })();

  // ---------- Cookie preferences modal trigger ----------
  document.addEventListener('click', (e) => {
    const trg = e.target.closest('[data-cookie-prefs]');
    if (!trg) return;
    e.preventDefault();
    let modal = document.getElementById('cookie-prefs-modal');
    if (!modal) {
      const isEn = (document.documentElement.lang || '').startsWith('en');
      modal = document.createElement('div');
      modal.id = 'cookie-prefs-modal';
      modal.className = 'modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="modal__overlay" data-modal-close></div><div class="modal__panel"><button type="button" class="modal__close" data-modal-close aria-label="' + (isEn ? 'Close' : 'Затвори') + '"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l12 12M16 4L4 16"/></svg></button><h2>' + (isEn ? 'Cookie preferences' : 'Бисквитки — настройки') + '</h2><p class="dim" style="font-size:13px;margin-bottom:24px;">' + (isEn ? 'Choose which cookie categories you allow.' : 'Избери кои категории бисквитки да разрешиш.') + '</p><div class="cookie-prefs__option"><div><h3 class="cookie-prefs__title">' + (isEn ? 'Essential' : 'Задължителни') + '</h3><p class="cookie-prefs__desc">' + (isEn ? 'Required for the site to function.' : 'Нужни за работата на сайта.') + '</p></div><label class="toggle-switch"><input type="checkbox" checked disabled><span class="toggle-switch__slider"></span></label></div><div class="cookie-prefs__option"><div><h3 class="cookie-prefs__title">' + (isEn ? 'Analytics' : 'Анализи') + '</h3><p class="cookie-prefs__desc">' + (isEn ? 'Help us improve by tracking usage.' : 'Помагат за подобрение чрез измерване.') + '</p></div><label class="toggle-switch"><input type="checkbox" data-cookie-cat="analytics"><span class="toggle-switch__slider"></span></label></div><div class="cookie-prefs__option"><div><h3 class="cookie-prefs__title">' + (isEn ? 'Marketing' : 'Маркетинг') + '</h3><p class="cookie-prefs__desc">' + (isEn ? 'Personalized ads + retargeting pixels.' : 'Персонализирани реклами + ретаргетинг.') + '</p></div><label class="toggle-switch"><input type="checkbox" data-cookie-cat="marketing"><span class="toggle-switch__slider"></span></label></div><div style="display:flex;gap:8px;margin-top:24px;"><button type="button" class="btn btn-secondary" data-modal-close>' + (isEn ? 'Cancel' : 'Отказ') + '</button><button type="button" class="btn btn-primary" data-cookie-save>' + (isEn ? 'Save preferences' : 'Запази') + '</button></div></div>';
      document.body.appendChild(modal);
      // Pre-fill from existing prefs
      try {
        const prefs = JSON.parse(localStorage.getItem('st_cookie_prefs') || '{}');
        modal.querySelectorAll('[data-cookie-cat]').forEach(cb => {
          if (prefs[cb.dataset.cookieCat]) cb.checked = true;
        });
      } catch (_) {}
      // Save handler
      modal.querySelector('[data-cookie-save]').addEventListener('click', () => {
        const prefs = {};
        modal.querySelectorAll('[data-cookie-cat]').forEach(cb => { prefs[cb.dataset.cookieCat] = cb.checked; });
        localStorage.setItem('st_cookie_prefs', JSON.stringify(prefs));
        localStorage.setItem('st_cookie_consent', 'custom');
        window.silentTraxModal.close(modal);
        if (window.silentTraxToast) window.silentTraxToast('OK', { kind: 'success' });
      });
    }
    window.silentTraxModal.open(modal);
  });

  // ---------- Article auto-add to recently viewed ----------
  (function trackProductView() {
    if (document.body.classList.contains('template-product')) {
      const handle = document.body.dataset.productHandle;
      if (!handle) return;
      let list = [];
      try { list = JSON.parse(localStorage.getItem('st_recently_viewed') || '[]'); } catch (_) {}
      list = list.filter(h => h !== handle);
      list.unshift(handle);
      list = list.slice(0, 20);
      localStorage.setItem('st_recently_viewed', JSON.stringify(list));
    }
  })();

  // ---------- Compare floating CTA ----------
  (function compareFloatingCTA() {
    function getList() {
      try { return JSON.parse(localStorage.getItem('st_compare') || '[]'); } catch (_) { return []; }
    }
    function syncCTA() {
      const list = getList();
      let cta = document.querySelector('.compare-floating-cta');
      if (list.length >= 2) {
        if (!cta) {
          cta = document.createElement('a');
          cta.href = '#compare-modal';
          cta.className = 'compare-floating-cta';
          cta.setAttribute('data-compare-open', '');
          const isEn = (document.documentElement.lang || '').startsWith('en');
          cta.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg><span>' + (isEn ? 'Compare' : 'Сравни') + '</span><span class="compare-floating-cta__count">' + list.length + '</span>';
          document.body.appendChild(cta);
          requestAnimationFrame(() => cta.classList.add('is-visible'));
        } else {
          const countEl = cta.querySelector('.compare-floating-cta__count');
          if (countEl) countEl.textContent = list.length;
        }
      } else if (cta) {
        cta.classList.remove('is-visible');
        setTimeout(() => cta.remove(), 400);
      }
    }
    syncCTA();
    window.addEventListener('storage', (e) => { if (e.key === 'st_compare') syncCTA(); });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-compare-toggle]')) {
        setTimeout(syncCTA, 80);
      }
    });
  })();

  // ---------- Sticky TOC for policies + articles ----------
  (function stickyTOC() {
    const container = document.querySelector('.rte, .page-content, article .article__body');
    if (!container) return;
    const headings = container.querySelectorAll('h2, h3');
    if (headings.length < 3) return; // not worth a TOC for short pages
    const slug = (s) => s.toLowerCase().trim().replace(/[^a-zа-я0-9\s-]/gi, '').replace(/\s+/g, '-').slice(0, 60);
    headings.forEach(h => {
      if (!h.id) h.id = slug(h.textContent || '') || ('s-' + Math.random().toString(36).slice(2, 8));
    });
    // Build TOC list
    const toc = document.createElement('nav');
    toc.className = 'toc-sticky';
    const isEn = (document.documentElement.lang || '').startsWith('en');
    toc.setAttribute('aria-label', isEn ? 'Table of contents' : 'Съдържание');
    toc.innerHTML = '<div class="toc-sticky__title">' + (isEn ? 'On this page' : 'На страницата') + '</div><ul class="toc-sticky__list"></ul>';
    const list = toc.querySelector('.toc-sticky__list');
    headings.forEach(h => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'toc-sticky__link' + (h.tagName === 'H3' ? ' toc-sticky__link--sub' : '');
      a.href = '#' + h.id;
      a.textContent = h.textContent || '';
      a.dataset.tocTarget = h.id;
      li.appendChild(a);
      list.appendChild(li);
    });
    // Inject sidebar before container parent
    const parent = container.parentElement;
    if (parent && getComputedStyle(parent).display.indexOf('grid') === -1) {
      // Wrap in grid layout
      const wrap = document.createElement('div');
      wrap.style.cssText = 'display:grid;grid-template-columns:220px 1fr;gap:48px;align-items:start;';
      parent.insertBefore(wrap, container);
      wrap.appendChild(toc);
      wrap.appendChild(container);
    }
    // Active state via IO
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          const link = toc.querySelector('[data-toc-target="' + e.target.id + '"]');
          if (link && e.isIntersecting) {
            toc.querySelectorAll('.toc-sticky__link').forEach(l => l.classList.remove('is-active'));
            link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      headings.forEach(h => io.observe(h));
    }
  })();

  // ---------- H2 reveal-up (auto-class) ----------
  (function autoRevealH2() {
    document.querySelectorAll('main h2:not(.no-reveal):not(.product__title):not(.account__name)').forEach(h => {
      if (!h.classList.contains('reveal-h2')) h.classList.add('reveal-h2', 'reveal');
    });
    // Reveal-h2 elements are also .reveal — IO picks them up
  })();

  // ---------- Custom video controls overlay ----------
  (function videoControls() {
    document.querySelectorAll('.product-video-wrap video, .brand-video video').forEach(v => {
      const wrap = v.closest('.product-video-wrap, .brand-video');
      if (!wrap || wrap.dataset.controlsAttached) return;
      wrap.dataset.controlsAttached = '1';
      v.removeAttribute('controls');
      const controls = document.createElement('div');
      controls.className = 'product-video-controls';
      controls.innerHTML = '<button type="button" class="product-video-controls__btn" data-vid-toggle aria-label="Play/Pause"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></button><div class="product-video-controls__bar" data-vid-scrub><div class="product-video-controls__progress" data-vid-progress></div></div><button type="button" class="product-video-controls__btn" data-vid-mute aria-label="Mute"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z"/></svg></button>';
      wrap.appendChild(controls);
      const toggle = controls.querySelector('[data-vid-toggle]');
      const muteBtn = controls.querySelector('[data-vid-mute]');
      const scrub = controls.querySelector('[data-vid-scrub]');
      const progress = controls.querySelector('[data-vid-progress]');
      toggle.addEventListener('click', () => {
        if (v.paused) { v.play(); toggle.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>'; }
        else { v.pause(); toggle.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'; }
      });
      muteBtn.addEventListener('click', () => {
        v.muted = !v.muted;
      });
      v.addEventListener('timeupdate', () => {
        if (v.duration) progress.style.width = ((v.currentTime / v.duration) * 100) + '%';
      });
      scrub.addEventListener('click', (e) => {
        const r = scrub.getBoundingClientRect();
        if (v.duration) v.currentTime = ((e.clientX - r.left) / r.width) * v.duration;
      });
    });
  })();

  // ---------- Notification dot for cart/wishlist with items ----------
  (function notificationDots() {
    const sync = () => {
      const cartCount = parseInt(document.querySelector('.cart-count')?.dataset.count || '0', 10) || 0;
      let wishlist = [];
      try { wishlist = JSON.parse(localStorage.getItem('st_wishlist') || '[]'); } catch (_) {}
      const wishCount = Array.isArray(wishlist) ? wishlist.length : 0;
      document.querySelectorAll('.cart-bubble, .bottom-nav__item--cart').forEach(el => {
        el.classList.toggle('has-items', cartCount > 0);
      });
      document.querySelectorAll('.wish-bubble, .bottom-nav__item--wish').forEach(el => {
        el.classList.toggle('has-items', wishCount > 0);
      });
    };
    sync();
    document.addEventListener('st:cart-updated', sync);
    window.addEventListener('storage', (e) => { if (e.key === 'st_wishlist') sync(); });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-wishlist-toggle], .product-card__wishlist')) {
        setTimeout(sync, 60);
      }
    });
  })();

  // ---------- Hero h1 word-by-word reveal (progressive enhancement) ----------
  (function heroWordReveal() {
    const h = document.querySelector('.hero__title');
    if (!h || h.dataset.wordsSplit) return;
    h.dataset.wordsSplit = '1';
    const text = h.textContent.trim();
    if (!text) return;
    h.innerHTML = text.split(/\s+/).map(w => `<span class="word">${w}</span>`).join(' ');
    // Add stagger-ready, then trigger is-revealed via setTimeout (more reliable than nested RAF)
    h.classList.add('stagger-ready');
    setTimeout(() => h.classList.add('is-revealed', 'is-visible'), 80);
    // Safety net: also fire on load event
    window.addEventListener('load', () => h.classList.add('is-revealed', 'is-visible'), { once: true });
  })();

  // ---------- Floating label upgrade for plain inputs ----------
  (function floatingLabels() {
    document.querySelectorAll('input, textarea').forEach(input => {
      // Skip if already inside field-float, or doesn't have placeholder
      if (input.closest('.field-float')) return;
      // Set placeholder=" " so :not(:placeholder-shown) works for plain text inputs
      if (input.matches('input[type=text], input[type=email], input[type=tel], input[type=search], textarea')) {
        if (!input.hasAttribute('placeholder') || input.getAttribute('placeholder') === '') {
          // skip — we won't force placeholder on inputs that didn't have one
        } else if (input.placeholder && input.placeholder !== ' ') {
          // keep placeholder; no floating upgrade
        }
      }
    });
  })();

  // ---------- PDP image lightbox ----------
  (function imageLightbox() {
    // Find candidate images: PDP main, gallery main, model viewer slot
    const targets = document.querySelectorAll('.product__media-main img, .product__media-item img.product__zoomable, .product__gallery-main img');
    let box = null;
    function open(srcOrImg) {
      if (!box) {
        box = document.createElement('div');
        box.className = 'lightbox';
        box.setAttribute('aria-hidden', 'true');
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        const isEn = (document.documentElement.lang || '').startsWith('en');
        box.innerHTML = '<button type="button" class="lightbox__close" aria-label="' + (isEn ? 'Close' : 'Затвори') + '"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16"/></svg></button><img class="lightbox__img" alt="">';
        document.body.appendChild(box);
        const close = () => { box.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-lightbox-open'); };
        box.querySelector('.lightbox__close').addEventListener('click', close);
        box.addEventListener('click', (e) => { if (e.target === box || e.target.classList.contains('lightbox__img')) close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && box.getAttribute('aria-hidden') === 'false') close(); });
      }
      const img = box.querySelector('.lightbox__img');
      const src = typeof srcOrImg === 'string' ? srcOrImg : (srcOrImg.dataset.zoom || srcOrImg.currentSrc || srcOrImg.src);
      const alt = typeof srcOrImg === 'string' ? '' : (srcOrImg.alt || '');
      img.src = src;
      img.alt = alt;
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-lightbox-open');
    }
    targets.forEach(img => {
      img.classList.add('product__zoomable');
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => open(img));
    });
    window.silentTraxLightbox = open;
  })();

  // ---------- Hero subtle parallax (transforms applied via CSS custom property) ----------
  (function heroParallax() {
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const heroBg = document.querySelector('.hero__bg');
    if (!heroBg) return;
    let ticking = false;
    const onScroll = () => {
      const y = Math.min(window.scrollY, 800);
      heroBg.style.setProperty('--hero-y', (y * -0.15) + 'px');
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();
  })();

  // ---------- Wishlist filled-heart state restore from localStorage ----------
  (function wishlistStateRestore() {
    let wishlist = [];
    try { wishlist = JSON.parse(localStorage.getItem('st_wishlist') || '[]'); } catch (_) {}
    if (!Array.isArray(wishlist) || !wishlist.length) return;
    const apply = () => {
      document.querySelectorAll('[data-wishlist-toggle], .product-card__wishlist').forEach(btn => {
        const handle = btn.dataset.wishlistHandle || btn.dataset.handle || btn.closest('[data-product-handle]')?.dataset.productHandle;
        if (handle && wishlist.includes(handle)) {
          btn.setAttribute('aria-pressed', 'true');
          btn.classList.add('is-active');
        }
      });
    };
    apply();
    // Re-apply after DOM mutations (e.g., loaded recently-viewed)
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => apply());
      mo.observe(document.body, { subtree: true, childList: true });
    }
  })();

  // ---------- Link prefetch on hover/touchstart (smart prefetching) ----------
  (function smartPrefetch() {
    if (!('IntersectionObserver' in window) || !('querySelector' in document)) return;
    // Respect Save-Data header preference
    if (navigator.connection && navigator.connection.saveData) return;
    const prefetched = new Set();
    const prefetch = (href) => {
      if (prefetched.has(href)) return;
      try {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname) return;
      } catch (_) { return; }
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
      prefetched.add(href);
    };
    const onHover = (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.dataset.noPrefetch !== undefined) return;
      a.dataset.prefetched = '1';
      prefetch(a.href);
    };
    document.addEventListener('mouseover', onHover, { passive: true });
    document.addEventListener('touchstart', onHover, { passive: true });
  })();

  // ---------- Cart count bump on cart updates ----------
  document.addEventListener('st:cart-updated', () => {
    document.querySelectorAll('.cart-count, .bottom-nav__count').forEach(el => {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
      setTimeout(() => el.classList.remove('is-bumped'), 580);
    });
  });

  // ---------- iOS Add to Home Screen hint (one-time per device) ----------
  (function iosAddToHome() {
    const KEY = 'st_a2hs_dismissed';
    if (localStorage.getItem(KEY)) return;
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isIOS || !isSafari || isStandalone) return;
    setTimeout(() => {
      const isBG = (document.documentElement.lang || '').startsWith('bg');
      const hint = document.createElement('div');
      hint.className = 'pwa-hint';
      hint.setAttribute('role', 'dialog');
      hint.setAttribute('aria-live', 'polite');
      hint.innerHTML = isBG
        ? '<div class="pwa-hint__msg"><strong>Бърз достъп</strong>Добави SilentTrax на твоя начален екран — натисни <b>Сподели</b> → <b>Add to Home Screen</b>.</div><button type="button" class="pwa-hint__close" aria-label="Затвори">✕</button>'
        : '<div class="pwa-hint__msg"><strong>Quick access</strong>Add SilentTrax to your Home Screen — tap <b>Share</b> → <b>Add to Home Screen</b>.</div><button type="button" class="pwa-hint__close" aria-label="Close">✕</button>';
      document.body.appendChild(hint);
      requestAnimationFrame(() => hint.classList.add('is-visible'));
      hint.querySelector('.pwa-hint__close').addEventListener('click', () => {
        hint.classList.remove('is-visible');
        setTimeout(() => hint.remove(), 320);
        localStorage.setItem(KEY, String(Date.now()));
      });
    }, 12000);
  })();

  // ---------- Back-to-top button ----------
  (function backToTop() {
    if (document.querySelector('.back-to-top')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 14 6-6 6 6"/></svg>';
    document.body.appendChild(btn);
    let ticking = false;
    const onScroll = () => {
      btn.classList.toggle('is-visible', window.scrollY > 600);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    btn.addEventListener('click', () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });
  })();

  // ---------- Trust strip / generic count-up via [data-counter] ----------
  (function dataCounterObserver() {
    const els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.counter || el.textContent.replace(/[^\d.]/g, '')) || 0;
        const decimals = (el.dataset.counterDecimals !== undefined) ? parseInt(el.dataset.counterDecimals, 10) : 0;
        const duration = parseInt(el.dataset.counterDuration || '1400', 10);
        const prefix = el.dataset.counterPrefix || '';
        const suffix = el.dataset.counterSuffix || '';
        const start = performance.now();
        el.classList.add('is-counting');
        function step(t) {
          const p = Math.min(1, (t - start) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          const current = target * eased;
          el.textContent = prefix + current.toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.classList.remove('is-counting');
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(el => io.observe(el));
  })();

  // ---------- Newsletter success animation ----------
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.newsletter, [data-newsletter]');
    if (!form) return;
    // Intentionally do not preventDefault — Shopify handles submit. But mark for visual reward when page returns.
    sessionStorage.setItem('st_newsletter_submitted', '1');
  });
  if (sessionStorage.getItem('st_newsletter_submitted') === '1') {
    sessionStorage.removeItem('st_newsletter_submitted');
    const successEls = document.querySelectorAll('.newsletter__success, [data-newsletter-success]');
    successEls.forEach(el => {
      if (!el.querySelector('.newsletter__success-icon')) {
        const icon = document.createElement('span');
        icon.className = 'newsletter__success-icon';
        icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l3 3 5-6"/></svg>';
        el.prepend(icon);
      }
    });
  }

  // ---------- Ride builder (multi-product configurator) ----------
  (function rideBuilder() {
    const form = document.querySelector('[data-ride-builder-form]');
    if (!form) return;
    const itemsBox = form.querySelector('[data-rb-items]');
    const totalEl = form.querySelector('[data-rb-total]');
    const linesEl = form.querySelector('[data-rb-lines]');
    const addBtn = form.querySelector('[data-rb-add]');
    const emptyMsg = form.querySelector('[data-rb-empty]');
    const money = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function recompute() {
      const picks = Array.from(form.querySelectorAll('[data-rb-pick]')).filter((i) => i.checked && i.value);
      itemsBox.innerHTML = '';
      let total = 0;
      const lines = [];
      picks.forEach((inp, i) => {
        const price = parseInt(inp.dataset.price || '0', 10) || 0;
        total += price;
        lines.push('<div class="rb-sum__line"><span>' + esc(inp.dataset.title || '') + '</span><span class="mono">' + money(price) + '</span></div>');
        itemsBox.insertAdjacentHTML('beforeend',
          '<input type="hidden" name="items[' + i + '][id]" value="' + esc(inp.value) + '">' +
          '<input type="hidden" name="items[' + i + '][quantity]" value="1">');
      });
      if (totalEl) totalEl.textContent = money(total);
      if (linesEl) linesEl.innerHTML = lines.join('');
      const has = picks.length > 0;
      if (addBtn) addBtn.disabled = !has;
      if (emptyMsg) emptyMsg.hidden = has;
    }

    form.addEventListener('change', (e) => {
      if (e.target.closest('[data-rb-pick]')) recompute();
    });
    recompute();
  })();

})();
